import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsES: CultureInfo = {
  name: 'es-ES',
  displayName: 'Spanish (Spain)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-ES',
  parent: CultureInfoEs
};
